var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconToilet = function SvgIconToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 9.125H5V3.75A1.75 1.75 0 0 1 6.75 2h10.5A1.75 1.75 0 0 1 19 3.75v5.375h1.25a1 1 0 0 1 1 1 9.25 9.25 0 0 1-4.977 8.204l.346 2.427v.003a1.75 1.75 0 0 1-1.728 1.991H9.11a1.75 1.75 0 0 1-1.728-1.99v-.004l.346-2.427a9.24 9.24 0 0 1-4.978-8.204 1 1 0 0 1 1-1m5.498 7.708-.08-.034a7.25 7.25 0 0 1-4.349-5.674H19.18a7.25 7.25 0 0 1-9.932 5.708m.395 2.237-.24 1.68h5.195l-.24-1.68a9.25 9.25 0 0 1-4.715 0M17 9.125H7V4h10zm-7.625-3.75a1 1 0 0 0 0 2h1.5a1 1 0 1 0 0-2z",
    clipRule: "evenodd"
  })));
};
export default SvgIconToilet;